import React, { ReactNode, useState } from 'react';
import Spinner from 'components/spinner';

import {
  getSessionId,
  setSessionId,
  setRedirectUrl,
} from 'utils/sessionStorage';
import { redirectToAuthService } from 'utils/redirectToAuthService';

interface IWithAuth {
  children: ReactNode;
}

const getOrigin = (target: Window) =>
  target.location.protocol + '//' + target.location.hostname;

let windowInstance: Window = window;
export const setWindowInstance = (w: Window) => {
  windowInstance = w;
};

export default function WithAuth({ children }: IWithAuth) {
  const [sessionId, set_sessionId] = useState<string>(getSessionId());
  const [dataIsComing] = useState<boolean>(
    !!new URLSearchParams(windowInstance.location.search).get('more_data')
  );

  const parseMoreData = (
    message: Partial<{ data: string; origin: string }>
  ) => {
    if (
      message.origin !== getOrigin(windowInstance) ||
      typeof message.data !== 'string'
    ) {
      return;
    }

    if (message?.data?.indexOf('sessionId:') !== -1) {
      const id: string = message.data.replace('sessionId:', '');
      if (id !== 'empty') {
        setSessionId(message.data.replace('sessionId:', ''));
        set_sessionId(message.data.replace('sessionId:', ''));
        windowInstance.opener?.postMessage.apply(windowInstance.opener, [
          'received',
          message.origin,
        ]);
        windowInstance.removeEventListener.apply(window, [
          'message',
          parseMoreData as EventListener,
        ]);
      } else {
        console.log('received empty session id');
      }
    }
  };

  windowInstance.removeEventListener('message', parseMoreData);
  windowInstance.addEventListener('message', parseMoreData);

  if (!sessionId && !dataIsComing) {
    console.log('Needs authentication…');
    setRedirectUrl(windowInstance.location.pathname);
    redirectToAuthService(windowInstance.location.assign.bind(window.location));
    return <Spinner />;
  }

  if (
    !sessionId &&
    dataIsComing &&
    windowInstance.self !== windowInstance.opener &&
    windowInstance.opener
  ) {
    console.log('Loaded, waiting data…');
    windowInstance.opener?.postMessage.apply(windowInstance.opener, [
      'loaded',
      getOrigin(windowInstance),
    ]);
    return <Spinner />;
  }

  if (sessionId) {
    console.log('Received data…');
    windowInstance.history.replaceState.apply(windowInstance.history, [
      {},
      '',
      windowInstance.location.href.split('?')[0],
    ]);
    return <>{children}</>;
  }

  console.error('Unidentified error');
  return <Spinner />;
}
